module.exports = __webpack_public_path__ + "static/media/img12.a3f3f8dd.jpg";